// FormTranslatedEditor.jsx

import React from "react";
import { useFormikContext } from "formik";
import TranslatedEditor from "../TranslatedEditor";
import i18n from "i18next";

const FormTranslatedEditor = ({
  name,
  languages = ["de", "en", "it"],
  initialLanguage = i18n.language,
  ...rest
}) => {
  const { values, errors, setFieldValue } = useFormikContext();

  const handleChange = (fieldName, content) => {
    setFieldValue(fieldName, content);
  };

  return (
    <TranslatedEditor
      name={name}
      values={values}
      errors={errors}
      languages={languages}
      initialLanguage={initialLanguage}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default FormTranslatedEditor;
